import PropTypes from 'prop-types';
import React, { useState } from 'react';

const Password = (props) => {
  const { hideLabel, label, width, className, info, inputRef, suffix, error, ...rest } = props;
  const [type, setType] = useState('password');
  const toggleType = () => {
    if (type === 'password') setType('text');
    else if (type === 'text') setType('password');
  };
  return (
    <div className={`input-outer-container ${className ? className : ''}`}>
      {!hideLabel && (
        <label className="input-label label-text">
          <span className="span-text">{label}</span>
          <span style={{ flexGrow: 1 }}></span>
          <span className="input-error-box">{error ? error : '\u00A0'}</span>
          &nbsp;
          <span>{typeof info === 'function' ? info() : (info ?? '')}</span>
        </label>
      )}
      <div className="input-inner-container" style={{ border: props.error ? '1px red solid' : '' }}>
        <input
          ref={inputRef}
          className="input-element"
          type={type}
          {...rest}
          style={{
            borderTopRightRadius: suffix ? '0px' : undefined,
            borderBottomRightRadius: suffix ? '0px' : undefined,
          }}
        />
        {typeof suffix === 'function' ? suffix() : (suffix ?? '')}
        {/* {type === 'password' && <span width="1.3rem" style={{marginRight: '10px',  color: "#00857d" }} onClick={toggleType}></span>} */}
        {type === 'text' && (
          <span width="1.9rem" style={{ marginRight: '10px', color: '#00857d' }} onClick={toggleType}></span>
        )}
      </div>
    </div>
  );
};

Password.propTypes = {
  hideLabel: PropTypes.string,
  label: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  info: PropTypes.string,
  value: PropTypes.string,
  inputRef: PropTypes.string,
  suffix: PropTypes.string,
  error: PropTypes.string,
  consoleFont: PropTypes.string,
  fullWidth: PropTypes.string,
  classNameInputField: PropTypes.string,
  reportStyle: PropTypes.string,
  numeric: PropTypes.number,
};

export default Password;
